export default __webpack_public_path__ + "static/Do-Keep-content-simple-and-focused-95995ecb979bcbfae8bb13834ab5b795eda62ed5f992457157898176db2ce8b0.png";